<template>
  <el-dialog title="添加子指标" :visible.sync="visible" width="30%" @close="cancelHandle">
    <div>
      <el-form ref="form" :model="form" label-width="140px" :rules="formRules">
        <el-form-item label="评价指标：" prop="evaluateName">
          <el-input clearable type="text" v-model="form.evaluateName" />
        </el-form-item>
        <el-form-item label="评价指标辅助解释：" prop="evaluateExplain">
          <el-input clearable type="text" v-model="form.evaluateExplain" />
        </el-form-item>
        <el-form-item label="评价方式：" prop="evaluateConfigName">
          <el-cascader
            v-model="form.evaluateConfigName"
            :options="optionevaluateConfigName"
            :show-all-levels="false"
            @change="handleChangeMethods"
            placeholder="必须选择到最末级"
          ></el-cascader>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelHandle">取 消</el-button>
      <el-button type="primary" @click="sureHandle">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import {
  getSubjectevaluateOption,
  getIndicatorsSaveData
} from "@/server/mainCredit.js";
export default {
  props: ["visibleValue", "rowInfo", "roleType"],
  data() {
    return {
      idNum: "",
      visible: this.visibleValue,
      evaluateConfigName: [],
      dataInfoAll: [],
      optionevaluateConfigName: [
        {
          value: "1",
          label: "A打分评价",
          children: []
        },
        {
          value: "2",
          label: "B选项评价（星级评价、是否、好中差等）",
          children: [
            {
              value: "3",
              label: "二级满意评价度",
              children: []
            },
            {
              value: "4",
              label: "三级满意评价度",
              children: []
            },
            {
              value: "5",
              label: "五级满意评价度",
              children: []
            }
          ]
        }
      ],
      form: {
        evaluateName: "",
        evaluateExplain: "",
        evaluateConfigName: "",
        evaluateConfigId: ""
      },
      formRules: {
        evaluateName: [
          {
            required: true,
            message: "请选择评价指标",
            trigger: ["blur", "change"]
          }
        ],
        evaluateExplain: [
          {
            required: true,
            message: "请填写评价指标辅助解释",
            trigger: ["blur", "change"]
          }
        ],
        evaluateConfigName: [
          {
            required: true,
            message: "请选择评价方式",
            trigger: ["blur", "change"]
          }
        ]
      }
    };
  },
  watch: {
    visibleValue: {
      immediate: true,
      handler(val) {
        this.visible = val;
      }
    },
    roleType: {
      immediate: true,
      handler(val) {
        this.roleType = val;
      }
    }
  },
  mounted() {
    this.handleFocusMethods();
  },
  methods: {
    handleClose() {},
    cancelHandle() {
      this.$emit("visibleDialogfalse");
      this.$refs.form.resetFields();
    },
    async sureHandle() {
      let parmData;
      if (this.rowInfo) {
        parmData = {
          roleType: this.roleType,
          parentId: this.rowInfo.id,
          evaluateConfigId: this.form.evaluateConfigId || "",
          openFlag: 1,
          evaluateName: this.form.evaluateName,
          evaluateExplain: this.form.evaluateExplain,
          evaluateConfigName: this.evaluateConfigName,
          level: this.rowInfo.level + 1 || 1
        };
      } else {
        parmData = {
          roleType: this.roleType,
          evaluateConfigId: this.form.evaluateConfigId || "",
          openFlag: 1,
          evaluateName: this.form.evaluateName,
          evaluateExplain: this.form.evaluateExplain,
          evaluateConfigName: this.evaluateConfigName,
          level: 1
        };
      }
      // 把值存入后端
      this.$refs["form"].validate(valid => {
        if (valid) {
          getIndicatorsSaveData(parmData).then(res => {
            if (res.data.code == "1") {
              this.idNum = res.data.data.id;
              // this.$message.success("添加成功");
              this.$message({
                message: "添加成功",
                type: "success",
                customClass: "messageIndex"
              });
            }
            this.$emit("visibleDialogSure", this.idNum);
          });
        } else {
          // this.$message.error("还有数据未填写");
          this.$message({
                message: "还有数据未填写",
                type: "error",
                customClass: "messageIndex"
              });
          return false;
        }
      });
    },

    // 级联选择
    handleChangeMethods(value) {
      console.log(value, "先休息");
      let evaluateConfigId = value[value.length - 1];
      this.form.evaluateConfigId = evaluateConfigId;
      let filters = this.dataInfoAll.filter(item => {
        return item.id === evaluateConfigId;
      });
      if (filters.length > 0) {
        this.evaluateConfigName = filters[0].evaluateName;
      }
    },
    handleFocusMethods() {
      getSubjectevaluateOption({
        page: 1,
        rows: 1000
      }).then(res => {
        let dataInfoAll = res.data.rows || [];
        dataInfoAll.forEach(item => {
          // 打分评价
          if (item.type === 1) {
            this.optionevaluateConfigName[0].children.push({
              value: item.id,
              label: item.evaluateName
            });
          } else if (item.type === 2) {
            // 选项评价
            if (item.level == 1) {
              this.optionevaluateConfigName[1].children[0].children.push({
                value: item.id,
                label: item.evaluateName
              });
            }
            if (item.level == 2) {
              this.optionevaluateConfigName[1].children[1].children.push({
                value: item.id,
                label: item.evaluateName
              });
            }
            if (item.level == 3) {
              this.optionevaluateConfigName[1].children[2].children.push({
                value: item.id,
                label: item.evaluateName
              });
            }
          }
        });

        this.dataInfoAll = dataInfoAll;
      });
    }
  }
};
</script>
<style lang="less">
  
</style>